(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-seo-content"]) return;
  try {
    
  class ExpandableText extends HTMLElement {
    #body;
    #toggle;
    #readMoreLabel;
    #readLessLabel;

    connectedCallback() {
      this.#body = this.querySelector('.collection-seo-content__body');
      this.#toggle = this.querySelector('.collection-seo-content__toggle');

      if (!this.#body || !this.#toggle) return;

      this.#readMoreLabel = this.dataset.readMoreLabel || 'Read more';
      this.#readLessLabel = this.dataset.readLessLabel || 'Read less';

      this.#evaluateOverflow();
      this.#toggle.addEventListener('click', this.#onToggle);

      window.addEventListener('resize', this.#evaluateOverflow, { passive: true });
    }

    disconnectedCallback() {
      this.#toggle?.removeEventListener('click', this.#onToggle);
      window.removeEventListener('resize', this.#evaluateOverflow);
    }

    #evaluateOverflow = () => {
      if (this.classList.contains('is-expanded')) {
        this.#toggle.hidden = false;
        return;
      }
      const overflows = this.#body.scrollHeight - this.#body.clientHeight > 1;
      this.#toggle.hidden = !overflows;
    };

    #onToggle = () => {
      const expanded = this.classList.toggle('is-expanded');
      this.#toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      this.#toggle.textContent = expanded ? this.#readLessLabel : this.#readMoreLabel;
    };
  }

  if (!window.customElements.get('expandable-text')) {
    window.customElements.define('expandable-text', ExpandableText);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-offer-bar"] && !Shopify.designMode) return;
  try {
    
    window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
            const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
            thisHeader.classList.add("shoplift-offer-bar-sticky");

            const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

            const mainInitialTop = mainHeader.offsetTop;
            const stickyStart = mainHeader ? (mainHeader.offsetTop + mainHeader.clientHeight) : 0;
            let lastScroll = window.scrollY;
            document.addEventListener("scroll", (scrollEvent) => {
                if (!thisHeader) return;

                // Do it quick and dirty
                const mainHidden = mainHeader && (window.scrollY > lastScroll);
                lastScroll = window.scrollY;

                const makeSticky = window.pageYOffset > stickyStart || mainHeader && window.pageYOffset > mainInitialTop && mainHeader.parentElement.classList.contains("shopify-section-header-sticky");

                thisHeader.classList.toggle("shoplift-offer-bar-sticky", makeSticky);

                if (!makeSticky) return;

                let topPosition = 0;

                if (mainHeader && !mainHidden)
                    topPosition += mainHeader.clientHeight;

                thisHeader.style.top = topPosition + "px";
            });
        }
    });

  } catch(e) { console.error(e); }
})();
})();
